import { Component } from '@angular/core';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';
import { DynamicFormService } from '@ntap/common';
import {
  ActionWindowParams,
  DEFAULT_ITEM_VIEW,
  EMPTY_ACTION_RESULT,
  ItemActionResult,
  ItemUtil,
  ViewResult,
  ViewResultListener,
  ViewState,
  ViewWindowComponent,
  WindowRegistry
} from '@ntap/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { filter, first, map, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'app-open-povezani-agent',
  templateUrl: './open-povezani-agent-action.component.html',
  providers: [
    {
      provide: ViewResultListener,
      useExisting: ViewWindowComponent
    },
    {
      provide: WindowRegistry,
      useClass: WindowRegistry
    },
    {
      provide: DynamicFormService,
      useClass: DynamicFormService
    }
  ]
})
export class OpenPovezaniAgentActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  static AGENT_VIEW_NAME = 'agent_item_readonly';

  protected override doExecuteWithItem(): Observable<ItemActionResult> {
    return this.itemProvider.item$.pipe(
      first(),
      switchMap((item: any) => {
        const agentId = item['sv~autor~identifikator'];

        const itemm: any = {
          $itemType: 'en~agent',
          $mainType: 'en~agent',
          $parentId: agentId,
          $parentType: 'en~agent',
          'en~agent~id': agentId
        };

        const itemProps =
          (agentId && {
            $id: agentId,
            $type: 'en~agent',
            $itemType: 'en~agent'
          }) ||
          {};

        const keyItem = ItemUtil.extractItemKey(itemm);

        const viewState = Object.assign({}, keyItem, itemProps);

        return this.doOpenWindow(viewState).pipe(
          filter((viewResult: any) => this.acceptResult(viewResult)),
          map(
            (viewResult) =>
              new ItemActionResult(EMPTY_ACTION_RESULT, viewResult.viewData[0])
          )
        );
      })
    );
  }

  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }

  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    const actionWindowParams = OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      OpenPovezaniAgentActionComponent.AGENT_VIEW_NAME
    );

    return actionWindowParams;
  }

  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = DEFAULT_ITEM_VIEW;
    }
  }
}
